<!-- <div class="h-full px-16px min-h-80vh flex justify-center items-center">
  <div class="flex justify-center items-center">
    <div class="max-w-450px">
      <ib-logo-name-horizontal
        class="w-220px block mx-auto"
      ></ib-logo-name-horizontal>

      <div class="text-24px text-center text-secondary mt-20 mb-10">
        {{ 'page.email-confirm.title' | transloco }}
      </div>
      <div class="text-center">
        {{ 'page.email-confirm.descr' | transloco }}
      </div>

      <div class="mt-5 text-center text-12px flex justify-center items-center">
        <i class="material-icons text-18px mr-8px">info_outline</i>
        <span> {{ 'page.email-confirm.expire-in' | transloco }}</span>
      </div>

      <br />
      <br />
      <div class="flex flex-col justify-center items-center">
        <div>
          {{ 'page.email-confirm.not-received' | transloco }}
        </div>
        <ib-btn-wrap btnType="link" [isLoading]="loading">
          <button
            mat-button
            type="button"
            [disabled]="loading"
            (click)="resend()"
            class="ib-btn ib-btn-link ib-btn-secondary"
          >
            <span class="text-12px"
              >{{ 'btn.resend' | transloco }}
              {{ 'page.email-confirm.conf-link' | transloco }}</span
            >
          </button>
        </ib-btn-wrap>
      </div>

      <div
        *ngIf="authFacadeS.authUser"
        class="flex flex-col justify-center items-center mt-20"
      >
        <button
          mat-button
          type="button"
          (click)="logout()"
          class="ib-btn ib-btn-outline ib-btn-secondary"
        >
          {{ 'btn.logout' | transloco }}
        </button>
      </div>
    </div>
  </div>
</div>
<ib-footer></ib-footer> -->
<div class="h-full px-16px min-h-80vh flex justify-center items-center">
  <div class="flex justify-center items-center">
    <div class="max-w-450px text-center">
      <ib-logo-name-horizontal class="w-220px block mx-auto"></ib-logo-name-horizontal>

      <div class="text-24px text-center text-secondary mt-20 mb-10">
        Account Activation
      </div>
      <div class="text-center">
        In order to activate your account, please remit funds to the following bank details:
        <br /><br />
        <strong>IBAN:</strong> IE05 BARC 9902 1244 5134 04 <br />
        <strong>BIC/SWIFT:</strong> BARCIE2D
      </div>
      <br />
        <button
          mat-button
          type="button"
          (click)="login()"
          class="ib-btn ib-btn-outline ib-btn-secondary"
        >
          {{ 'btn.login' | transloco }}
        </button>
    </div>
  </div>
</div>
<ib-footer></ib-footer>
